<form [formGroup]="formName" class="d-flex w-100 flex-column">
    @if (field?.name && field?.options) {
        <label [for]="field?.name" class="mb-3">{{ field?.label }}</label>
        <mat-radio-group [formControlName]="field?.name || ''" [matTooltip]="field?.tooltipMessage || ''">
            @for (option of field?.options; let optionIndex = $index; track optionIndex) {
                <mat-radio-button
                    [value]="option.value"
                    [name]="field?.name || ''"
                    class="me-3"
                    [disabled]="field?.isDisabled"
                >
                    {{ option.displayValue }}
                </mat-radio-button>
            }
        </mat-radio-group>
    }
</form>
